const DateTimeDisplay = ({ value, type, isDanger }) => {
    return (
      <div className={isDanger || type === '秒' ? 'countdown danger' : 'countdown'}>
        <p>{value}</p>
        <span style={{fontSize:'0.85rem'}}>{type}</span>
      </div>
    );
  };
  
  export default DateTimeDisplay;